import * as types from './types'
import moment from 'moment'
import globals from '../../../Plugins/globals'
import storage from '@/Plugins/storage'

export default {
  [types.SET_PAGER](state, data) {
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.RESET_MEASUREMENT](state, data) {
    state.measurement = JSON.parse(JSON.stringify(state.defaultMeasurement))
    state.measurement.user_id = data.userid
    state.measurement.organization_id = data.orgid
  },
  [types.SET_MEASUREMENT](state, data) {
    state.measurement = null
    if (data !== undefined && data !== null) {
      state.measurement = data
    }
    console.log('Got Measurement', state.measurement)
  },
  [types.SET_MEASUREMENTS](state, data) {
    state.measurements = []
    if (data !== undefined && data !== null) {
      state.measurements = data
      state.measurements.forEach((measurement) => {
        measurement.checked = false
        measurement.disabled = false
        measurement.date = moment(measurement.measurement_date).format(
          'MM/DD/YYYY'
        )
      })
      state.measurements = globals.sortArray(
        state.measurements,
        'measurement_date',
        'asc'
      )
    }
    console.log('Got Measurements', state.measurements)
  },
  [types.RESET_PHOTOS](state) {
    state.photos = []
  },
  [types.SET_PHOTO](state, data) {
    let found = state.photos.find((x) => parseInt(x.id) === -99)
    if (found) {
      found[data.code] = data.image
      found[`${data.code}_data`] = {
        filename: data.filename,
        base64: data.base64Content,
      }
    } else {
      let photo = {
        back_arms_down: '',
        back_double_bicep: '',
        checked: true,
        created_at: data.date,
        date: moment(data.date).format('MM/DD/YYYY'),
        disabled: false,
        front: '',
        front_double_bicep: '',
        id: -99,
        photo_date: data.date, // YYYY-MM-DD HH:mm:ss
        side_profile: '',
        user_id: data.userid,
        isNew: true,
      }
      photo[data.code] = data.image
      photo[`${data.code}_data`] = {
        filename: data.filename,
        base64: data.base64Content,
      }
      state.photos.push(photo)
      console.log('Added New Photo Set', state.photos)
    }
  },
  [types.SET_PHOTOS](state, data) {
    state.photos = []
    console.log('Setting Photos', data)
    if (data !== undefined && data !== null) {
      state.photos = data
      state.photos.forEach((photo) => {
        photo.checked = false
        photo.disabled = false
        photo.isNew = false
        photo.date = moment(photo.photo_date).format('MM/DD/YYYY')
      })
      state.photos = globals.sortArray(state.photos, 'photo_date', 'asc')
    }
    console.log('Got Photos', state.photos)
  },
  [types.UPDATE_PHOTOS](state, data) {
    console.log('Updating local Photos', data)
  },
  [types.SET_CHECKED](state, data) {
    if (data.for === 'Measurements') {
      let found = state.measurements.find(
        (x) => parseInt(x.id) === parseInt(data.id)
      )
      if (found) {
        found.checked = data.value
      }
      let filtered = state.measurements.filter((x) => x.checked)
      state.measurements.forEach((element) => {
        element.disabled = false
      })
      if (filtered.length >= 3) {
        state.measurements.forEach((element) => {
          if (!element.checked) {
            element.disabled = true
          }
        })
      }
    } else {
      let found = state.photos.find((x) => parseInt(x.id) === parseInt(data.id))
      if (found) {
        found.checked = data.value
      }
      let filtered = state.photos.filter((x) => x.checked)
      state.photos.forEach((element) => {
        element.disabled = false
      })
      if (filtered.length >= 3) {
        state.photos.forEach((element) => {
          if (!element.checked) {
            element.disabled = true
          }
        })
      }
    }
  },
  [types.SET_VO2_ASSESSMENTS](state, data) {
    state.vo2assessments = []
    if (data !== undefined && data !== null) {
      state.vo2assessments = data.data
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
    console.log('Got VO2 Assessments', state.vo2assessments)
  },
  [types.SET_VO2_ASSESSMENT](state, data) {
    state.vo2assessment = null
    if (data !== undefined && data !== null) {
      state.vo2assessment = data
    }
    console.log('Got VO2 Assessment', state.vo2assessment)
  },
}
